module.exports = __webpack_public_path__ + "img/614-42dfb3.png";